export default __webpack_public_path__ + "static/media/agua.496607d1.jpg";